import type { ILinkProps } from '../DrillThruItems/DrillThruTypes'
import { FoundationsConstants } from '../../../FoundationsConstants'
import { getBaseUrl, isSecurityFeatureAllowed, toBinary } from '../../../Utils'
import { formHelp } from '../../../Pages/FormsEngine/formHelpers'

declare let window: any

export interface LinkResult {
    LinkValues: ILinkProps
    IsLink: boolean
    LinkSetUpCallBack?: any
}

export function FoundationsJSTargetGenericObjectViewer( // ocv link
    functionParamsString: string,
    currentColumn: any,
    rowCounter: number,
    colCounter: number,
    vuId: number,
    cellTitle: string,
    launcherMode: any,
    colMinWidth: any,
    colMaxWidth: any,
    colWhiteSpace: any,
    LinkSetUpCallBack: any
): LinkResult {
    let result: LinkResult = {
        LinkSetUpCallBack: LinkSetUpCallBack,
        LinkValues: {
            id: 'error in creating id',
            title: 'error in creating title',
            href: '',
            style: {
                cursor: 'pointer',
                minWidth: colMinWidth,
                maxWidth: colMaxWidth,
                whiteSpace: colWhiteSpace,
            },
            onClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                try {
                    event.stopPropagation()
                } catch (error) {
                    console.error('An error occurred:', error)
                }
            },
        },
        IsLink: false,
    }

    try {
        let parsedFunctionParamsString = JSON.parse(
            functionParamsString ? functionParamsString : JSON.stringify(currentColumn)
        )
        parsedFunctionParamsString.mdsColumnID = currentColumn?.MDSColumnId

        result.LinkValues.id = `mdsc_${rowCounter + 1}_${colCounter}_${vuId}`
        result.LinkValues.title = cellTitle
        result.LinkValues.href = ''
        ;(result.LinkValues.style = {
            cursor: 'pointer',
            minWidth: colMinWidth,
            maxWidth: colMaxWidth,
            whiteSpace: colWhiteSpace,
        }),
            (result.LinkValues.onClick = (
                event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
            ) => {
                try {
                    event.stopPropagation()
                    event.preventDefault()
                    let clickThruElement = event.currentTarget as HTMLElement
                    let clickThruElementHTMLCont = clickThruElement?.innerHTML
                    LinkSetUpCallBack({
                        clickThruElement: clickThruElement,
                        objectContext: parsedFunctionParamsString,
                        launcherMode: launcherMode ? launcherMode : 'popup',
                    })
                } catch (error) {
                    console.error('An error occurred:', error)
                }
            })
        result.IsLink = true
    } catch (error) {
        console.error('Error parsing functionParamsString:', error)
    }

    return result
}

export function FoundationsJSTargetDrillThruDelete(
    currentColumn: any,
    rowCounter: number,
    colCounter: number,
    vuId: number,
    cellTitle: string,
    matchRegex: RegExpExecArray | null,
    colMinWidth: any,
    colMaxWidth: any,
    colWhiteSpace: any
): LinkResult {
    let result: LinkResult = {
        LinkValues: {
            id: 'error in creating id',
            title: 'error in creating title',
            href: '',

            style: {
                cursor: 'pointer',
                minWidth: colMinWidth,
                maxWidth: colMaxWidth,
                whiteSpace: colWhiteSpace,
            },
            onClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                try {
                    event.stopPropagation()
                } catch (error) {
                    console.error('An error occurred:', error)
                }
            },
        },
        IsLink: false,
    }

    try {
        result.LinkValues.id = `mdsc_${rowCounter}_${colCounter}_${vuId}`
        result.LinkValues.title = cellTitle
        result.LinkValues.href = ''
        ;(result.LinkValues.style = {
            cursor: 'pointer',
            minWidth: colMinWidth,
            maxWidth: colMaxWidth,
            whiteSpace: colWhiteSpace,
        }),
            (result.LinkValues.onClick = (
                event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
            ) => {
                try {
                    event.stopPropagation()
                    event.preventDefault() // Prevent the default anchor tag navigation
                    // If matchRegex is not null and matches, we proceed with the delete action
                    if (matchRegex) {
                        const [, first, second, third] = matchRegex
                        // Assuming you want to display a dialog or call a delete function
                        window.foundationsMDS.showDeleteMDSDialog(first, second, parseInt(third))
                    }
                } catch (error) {
                    console.error('An error occurred:', error)
                }
            })

        result.IsLink = false
    } catch (error) {
        console.error('Error setting up link:', error)
    }

    return result
}

export function FoundationsJSTargetAFHTicketViewer(
    functionParamsString: string,
    rowCounter: number,
    colCounter: number,
    vuId: number,
    cellTitle: string,
    colMinWidth: any,
    colMaxWidth: any,
    colWhiteSpace: any
): LinkResult {
    let result: LinkResult = {
        LinkValues: {
            id: 'error in creating id',
            title: 'error in creating title',
            href: '',

            style: {
                cursor: 'pointer',
                minWidth: colMinWidth,
                maxWidth: colMaxWidth,
                whiteSpace: colWhiteSpace,
            },

            onClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                try {
                    event.stopPropagation()
                } catch (error) {
                    console.error('An error occurred:', error)
                }
            },
        },
        IsLink: false,
    }

    try {
        result.LinkValues.id = `mdsc_${rowCounter}_${colCounter}_${vuId}`
        result.LinkValues.title = cellTitle
        result.LinkValues.href = ''
        ;(result.LinkValues.style = {
            cursor: 'pointer',
            minWidth: colMinWidth,
            maxWidth: colMaxWidth,
            whiteSpace: colWhiteSpace,
        }),
            (result.LinkValues.onClick = (
                event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
            ) => {
                try {
                    event.stopPropagation()
                    event.preventDefault() // Prevent the default anchor tag navigation
                    // Call the showRequestsFeedDialog function with the functionParamsString
                    window.foundationsAskForHelp.showRequestsFeedDialog(functionParamsString)
                } catch (error) {
                    console.error('An error occurred:', error)
                }
            })

        result.IsLink = false
    } catch (error) {
        console.error('Error setting up link:', error)
    }

    return result
}

export function FoundationsJSTargetPatientViewer(
    matchRegex: RegExpExecArray | null,
    rowCounter: number,
    colCounter: number,
    vuId: number,
    cellTitle: string,
    featureList: any[],
    colMinWidth: any,
    colMaxWidth: any,
    colWhiteSpace: any
): LinkResult {
    let result: LinkResult = {
        LinkValues: {
            id: 'error in creating id',
            title: 'error in creating title',
            href: '',

            style: {
                cursor: 'pointer',
                minWidth: colMinWidth,
                maxWidth: colMaxWidth,
                whiteSpace: colWhiteSpace,
            },
            onClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                try {
                    event.stopPropagation()
                } catch (error) {
                    console.error('An error occurred:', error)
                }
            },
        },
        IsLink: false,
    }

    try {
        const allowPatientLookup = isSecurityFeatureAllowed(featureList, ['AllowPatientLookup'])

        result.LinkValues.id = `mdsc_${rowCounter}_${colCounter}_${vuId}`
        result.LinkValues.title = cellTitle
        result.LinkValues.href = ''

        result.LinkValues.style = {
            cursor: 'pointer',
            minWidth: colMinWidth,
            maxWidth: colMaxWidth,
            whiteSpace: colWhiteSpace,
        }
        if (allowPatientLookup) {
            result.LinkValues.onClick = (
                event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
            ) => {
                try {
                    event.stopPropagation()
                    event.preventDefault() // Prevent the default anchor tag navigation
                    // Trigger the patient lookup if the regex match is valid
                    if (matchRegex) {
                        const [, first, second, third] = matchRegex
                        window.healthLevelPatientView.openPatientLookupDialog(
                            first,
                            second,
                            parseInt(third)
                        )
                    }
                } catch (error) {
                    console.error('An error occurred:', error)
                }
            }

            result.IsLink = false
        } else {
            // If the feature is not allowed, the link should not function
            result.LinkValues.onClick = (
                event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
            ) => {
                try {
                    event.stopPropagation()
                    event.preventDefault()
                    // You may still want to handle visual feedback when clicked, even if the link isn't functional
                } catch (error) {
                    console.error('An error occurred:', error)
                }
            }
            result.IsLink = false
        }
    } catch (error) {
        console.error('Error setting up link:', error)
    }

    return result
}

export function FoundationsJSTargetSmartObjectViewer( // ocv link
    rowCounter: number,
    colCounter: number,
    vuId: number,
    cellTitle: string,
    jsonRowEncryptedList: any[],
    colMinWidth: any,
    colMaxWidth: any,
    colWhiteSpace: any,
    LinkSetUpCallBack: any
): LinkResult {
    let result: LinkResult = {
        LinkValues: {
            id: 'error in creating id',
            title: 'error in creating title',
            href: '',

            style: {
                cursor: 'pointer',
                minWidth: colMinWidth,
                maxWidth: colMaxWidth,
                whiteSpace: colWhiteSpace,
            },
            onClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                try {
                    event.stopPropagation()
                } catch (error) {
                    console.error('An error occurred:', error)
                }
            },
        },
        IsLink: false,
    }

    try {
        // Create the objectContext
        const objectContext = { key: '', title: '', mdsColumnID: '' }

        // Access the encrypted object data
        const jsonRowEncryptedObject = jsonRowEncryptedList[colCounter]
        objectContext.key = jsonRowEncryptedObject.EncryptedKey
        objectContext.title = jsonRowEncryptedObject.Title
        objectContext.mdsColumnID = jsonRowEncryptedObject?.MDSColumnId

        result.LinkValues.id = `mdsc_${rowCounter}_${colCounter}_${vuId}`
        result.LinkValues.title = cellTitle
        result.LinkValues.href = ''

        result.LinkValues.style = {
            cursor: 'pointer',
            minWidth: colMinWidth,
            maxWidth: colMaxWidth,
            whiteSpace: colWhiteSpace,
        }
        // Define the onClick handler
        result.LinkValues.onClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
            try {
                event.stopPropagation()
                event.preventDefault() // Prevent the default anchor tag navigation

                let clickThruElement = document.getElementById(
                    `mdsc_${rowCounter}_${colCounter}_${vuId}`
                )
                LinkSetUpCallBack({
                    clickThruElement: clickThruElement,
                    objectContext: JSON.stringify(objectContext),
                    launcherMode: 'popup',
                    ocvType: 'SmartOCV',
                })
                // Open the object view dialog
                // window.healthlevelGenericObjectViewer.openObjectViewDialog(
                //     clickThruElement,
                //     JSON.stringify(objectContext),
                //     'popup',
                //     'SmartOCV'
                // );
            } catch (error) {
                console.error('An error occurred:', error)
            }
        }

        result.IsLink = true // Mark this as a valid link
    } catch (error) {
        console.error('Error setting up link:', error)
    }

    return result
}

export function FoundationsJSTargetDrillThruSet(
    rowCounter: number,
    colCounter: number,
    vuId: number,
    cellTitle: string,
    colMinWidth: any,
    colMaxWidth: any,
    colWhiteSpace: any
): LinkResult {
    let result: LinkResult = {
        LinkValues: {
            id: 'error in creating id',
            title: 'error in creating title',
            href: '',

            style: {
                cursor: 'pointer',
                minWidth: colMinWidth,
                maxWidth: colMaxWidth,
                whiteSpace: colWhiteSpace,
            },
            onClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                try {
                    event.stopPropagation()
                } catch (error) {
                    console.error('An error occurred:', error)
                }
            },
        },
        IsLink: false,
    }

    try {
        // Set the link properties
        // result.LinkValues.id = `mdsc_${rowCounter}_${colCounter}_${vuId}`;
        // result.LinkValues.title = cellTitle;
        // result.LinkValues.href = '';
        //
        result.LinkValues.style = {
            cursor: 'pointer',
            minWidth: colMinWidth,
            maxWidth: colMaxWidth,
            whiteSpace: colWhiteSpace,
        }
        // Mark as a valid link
        result.IsLink = false
    } catch (error) {
        console.error('Error setting up link:', error)
    }

    return result
}

export function APPLMSJSTarget(
    rowCounter: number,
    colCounter: number,
    vuId: number,
    cellTitle: string,
    matchRegex: RegExpExecArray | null,
    colMinWidth: any,
    colMaxWidth: any,
    colWhiteSpace: any,
    LinkSetUpCallBack: any
): LinkResult {
    let result: LinkResult = {
        LinkSetUpCallBack: LinkSetUpCallBack,
        LinkValues: {
            id: 'error in creating id',
            title: 'error in creating title',
            href: '',

            style: {
                cursor: 'pointer',
                minWidth: colMinWidth,
                maxWidth: colMaxWidth,
                whiteSpace: colWhiteSpace,
            },
            onClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                try {
                    event.stopPropagation()
                } catch (error) {
                    console.error('An error occurred:', error)
                }
            },
        },
        IsLink: false,
    }

    try {
        // const dispatch = useDispatch();
        result.LinkValues.id = `mdsc_${rowCounter}_${colCounter}_${vuId}`
        result.LinkValues.title = cellTitle
        result.LinkValues.href = ''

        result.LinkValues.style = {
            cursor: 'pointer',
            minWidth: colMinWidth,
            maxWidth: colMaxWidth,
            whiteSpace: colWhiteSpace,
        }

        result.LinkValues.onClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
            try {
                event.stopPropagation()
                event.preventDefault() // Prevent the default anchor tag navigation

                if (matchRegex) {
                    const matcRegex = /"id":\s*(\d+)/
                    const match = matchRegex[0].match(matcRegex)

                    if (match) {
                        const idValue = match[1]
                        LinkSetUpCallBack({
                            setLmsId: Number(idValue),
                        })
                    }
                }
            } catch (error) {
                console.error('An error occurred:', error)
            }
        }

        result.IsLink = true // Mark this as a valid link
    } catch (error) {
        console.error('Error setting up link:', error)
    }

    return result
}

export function FoundationsJSTargetStatPortalID( // ocv link
    functionParamsString: string,
    currentColumn: any,
    rowCounter: number,
    colCounter: number,
    vuId: number,
    cellTitle: string,
    launcherMode: any,
    drillThruVUObj: any,
    colMinWidth: any,
    colMaxWidth: any,
    colWhiteSpace: any,
    LinkSetUpCallBack: any
): LinkResult {
    let result: LinkResult = {
        LinkSetUpCallBack: LinkSetUpCallBack,
        LinkValues: {
            id: 'error in creating id',
            title: 'error in creating title',
            href: '',

            style: {
                cursor: 'pointer',
                minWidth: colMinWidth,
                maxWidth: colMaxWidth,
                whiteSpace: colWhiteSpace,
            },
            onClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                try {
                    event.stopPropagation()
                } catch (error) {
                    console.error('An error occurred:', error)
                }
            },
        },
        IsLink: false,
    }

    try {
        result.LinkValues.id = `mdsc_${rowCounter + 1}_${colCounter}_${vuId}`
        result.LinkValues.title = cellTitle
        result.LinkValues.href = ''
        ;(result.LinkValues.style = {
            cursor: 'pointer',
            minWidth: colMinWidth,
            maxWidth: colMaxWidth,
            whiteSpace: colWhiteSpace,
        }),
            (result.LinkValues.onClick = (
                event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
            ) => {
                try {
                    event.stopPropagation()
                    event.preventDefault()
                    const clickedText = (event.target as HTMLElement).innerText
                    let fixedString = functionParamsString.replace(/("id": )([\w\-]+)/, '$1"$2"')
                    const params = JSON.parse(fixedString)

                    if (params?.id) {
                        if (
                            clickedText === FoundationsConstants.StatPortalButtons.Removefrommylist
                        ) {
                            LinkSetUpCallBack({
                                SelectedVuId: drillThruVUObj.vuId,
                                SelectedAccessionNumber: params.id,
                                action: 'RELEASE',
                            })
                        } else if (
                            clickedText === FoundationsConstants.StatPortalButtons.Addtomylist
                        ) {
                            LinkSetUpCallBack({
                                SelectedVuId: drillThruVUObj.vuId,
                                SelectedAccessionNumber: params.id,
                                action: 'CLAIM',
                            })
                        } else {
                            LinkSetUpCallBack({
                                setStatPortalId: params.id,
                                SelectedVuId: drillThruVUObj.vuId,
                                action: 'VIEW',
                            })
                        }
                    }
                } catch (error) {
                    console.error('An error occurred:', error)
                }
            })
        result.IsLink = true
    } catch (error) {
        console.error('Error parsing functionParamsString:', error)
    }

    return result
}

export function CustomTargetURL(    
    functionParamsString: string,
    rowCounter: number,
    colCounter: number,
    vuId: number,
    cellTitle: string,
    colMinWidth: any,
    colMaxWidth: any,
    colWhiteSpace: any
){
    let result: LinkResult = {
        LinkValues: {
            id: 'error in creating id',
            title: 'error in creating title',
            href: '',

            style: {
                cursor: 'pointer',
                minWidth: colMinWidth,
                maxWidth: colMaxWidth,
                whiteSpace: colWhiteSpace,
            },
            onClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                try {
                    event.stopPropagation()
                } catch (error) {
                    console.error('An error occurred:', error)
                }
            },
        },
        IsLink: false,
    }

    try {
        // const dispatch = useDispatch();
        result.LinkValues.id = `mdsc_${rowCounter}_${colCounter}_${vuId}`
        result.LinkValues.title = cellTitle
        result.LinkValues.href = functionParamsString
        
        result.LinkValues.style = {
            cursor: 'pointer',
            minWidth: colMinWidth,
            maxWidth: colMaxWidth,
            whiteSpace: colWhiteSpace,
        }
        // Mark as a valid link
        result.IsLink = true
    } catch (error) {
        console.error('Error setting up link:', error)
    }

    return result
}

export function handleDefaultCase(
    rowCounter: number,
    functionParamsString: string,
    colCounter: number,
    vuId: number,
    currentColumn: any,
    JSONRowDataLists: any,
    drillThruVUObj: any,
    data_isEnabledAutoNavigation: boolean,
    data_drillThruSearchObj: any,
    cellTitle: string,
    colMinWidth: any,
    colMaxWidth: any,
    colWhiteSpace: any
): LinkResult {
    let result: LinkResult = {
        LinkValues: {
            id: 'error in creating id',
            title: 'error in creating title',
            href: '',

            style: {
                cursor: 'pointer',
                minWidth: colMinWidth,
                maxWidth: colMaxWidth,
                whiteSpace: colWhiteSpace,
            },
            onClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                try {
                    event.stopPropagation()
                } catch (error) {
                    console.error('An error occurred:', error)
                }
            },
        },
        IsLink: false,
    }

    try {
        let baseURL = getBaseUrl()
        if (baseURL.endsWith('/')) {
            baseURL = baseURL.slice(0, -1)
        }
        let deepLinkURL = currentColumn['javascriptTarget'].replace('$baseurl', baseURL)

        let templatedParams = deepLinkURL.match(/\$\d+/gi)
        if (templatedParams) {
            for (let match in templatedParams) {
                let positionalParam = Number(
                    templatedParams[match as unknown as number].replace('$', '')
                )
                deepLinkURL = deepLinkURL.replace(
                    templatedParams[match as unknown as number],
                    JSONRowDataLists.jsonRowList[positionalParam]
                )
            }
        }

        let requestEncodedObj: any = {
            vuId: vuId,
            pageNumber: drillThruVUObj.pageNumber,
            pageSize: drillThruVUObj.pageSize,
            id: `mdsc_${rowCounter}_${colCounter}_${vuId}`,
            drillThruDP: drillThruVUObj.drillThruDP,
            measureId: drillThruVUObj.drillThruDP?.meId,
            tempId: drillThruVUObj.tempVisualUnitId,
            isNavigationAllowed: data_isEnabledAutoNavigation,
            drillThrusetId: drillThruVUObj.drillThruSetId || -1,
            drillThruSearchString: drillThruVUObj.drillThruSearchString || '',
            InputSearchList: data_drillThruSearchObj,
            columnsData: JSONRowDataLists.sortColumnsData,
            MDSColumnId: currentColumn['MDSColumnId'],
        }

        if (deepLinkURL && deepLinkURL.includes('FormsEngine')) {
            let baseURLForLauncher =
                deepLinkURL +
                (functionParamsString
                    ? '?' +
                      functionParamsString +
                      '&guid=' +
                      formHelp.generateGuid() +
                      '&navigationenabled=' +
                      data_isEnabledAutoNavigation
                    : '?guid=' +
                      formHelp.generateGuid() +
                      '&navigationenabled=' +
                      data_isEnabledAutoNavigation)

            deepLinkURL = toBinary(JSON.stringify(requestEncodedObj))

            result.LinkValues = {
                id: `mdsc_${rowCounter}_${colCounter}_${vuId}`,
                title: cellTitle,
                href: '',
                onContextMenu: (e: any) => {
                    e.preventDefault()
                },
                style: {
                    cursor: 'pointer',
                    minWidth: colMinWidth,
                    maxWidth: colMaxWidth,
                    whiteSpace: colWhiteSpace,
                },
                onClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                    event.stopPropagation()
                    event.preventDefault() // Prevent the default anchor tag navigation
                    // setLinkColor('rgb(225, 112, 9)');
                    launchURL(baseURLForLauncher, deepLinkURL)
                },
            }
        } else {
            deepLinkURL =
                deepLinkURL +
                (functionParamsString ? '?' : '') +
                functionParamsString +
                (functionParamsString ? '&' : '?') +
                'drillThruParams=' +
                toBinary(JSON.stringify(requestEncodedObj))

            result.LinkValues = {
                id: `mdsc_${rowCounter}_${colCounter}_${vuId}`,
                title: cellTitle,
                href: deepLinkURL,

                style: {
                    cursor: 'pointer',
                    minWidth: colMinWidth,
                    maxWidth: colMaxWidth,
                    whiteSpace: colWhiteSpace,
                },
                onClick: () => {
                    // setLinkColor('rgb(225, 112, 9)');
                },
            }
        }

        result.IsLink = true
    } catch (error) {
        console.error('Error setting up link:', error)
    }

    return result
}

function launchURL(baseURLForLauncher: string, deepLinkUrl: any) {
    var child_window_handle = null
    child_window_handle = window.open(baseURLForLauncher, '_blank')
    const formChannel = new BroadcastChannel('form-data-' + baseURLForLauncher)
    formChannel.addEventListener('message', function (e) {
        if (e.data) {
            formChannel.postMessage(deepLinkUrl)
            formChannel.close()
        }
    })
}
